import axios from 'axios';

export const fetchRecomsNotificationsCount = async () => {
    try {
        const response = await axios.get('supports/moderation/count');

        return response.data;
    } catch (e) {
        const message = e.response?.data?.message || 'Ошибка загрузки данных';

        // eslint-disable-next-line no-throw-literal
        throw {
            message
        };
    }
};
